var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSlidersHorizontal = function SvgIconSlidersHorizontal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.359 8.84a1.874 1.874 0 0 1-3.217 0 1 1 0 0 1-.267.035H3.75a1 1 0 0 1 0-2h4.125a1 1 0 0 1 .267.036 1.874 1.874 0 0 1 3.217 0 1 1 0 0 1 .266-.036h8.625a1 1 0 1 1 0 2h-8.625a1 1 0 0 1-.267-.036M15.75 18c.683 0 1.28-.365 1.608-.91a1 1 0 0 0 .267.035h2.625a1 1 0 1 0 0-2h-2.625a1 1 0 0 0-.267.036 1.874 1.874 0 0 0-3.216 0 1 1 0 0 0-.267-.036H3.75a1 1 0 1 0 0 2h10.125a1 1 0 0 0 .267-.036c.327.546.925.911 1.608.911",
    clipRule: "evenodd"
  })));
};
export default SvgIconSlidersHorizontal;